import { colors } from "../theme";

interface ProgressBarProps {
  percentage: number; // 0-100
  leftLabel?: string;
  rightLabel?: string;
}

export default function ProgressBar({ percentage, leftLabel, rightLabel }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, percentage));

  return (
    <div>
      <div
        style={{
          position: "relative",
          height: 8,
          borderRadius: 4,
          background: colors.surfaceLight,
          overflow: "hidden",
        }}
      >
        {/* Fill */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: `${clamped}%`,
            borderRadius: 4,
            background: colors.primary,
            transition: "width 0.4s ease",
          }}
        />

        {/* Milestone markers at 25/50/75% */}
        {[25, 50, 75].map((m) => (
          <div
            key={m}
            style={{
              position: "absolute",
              top: 0,
              left: `${m}%`,
              width: 1,
              height: "100%",
              background: "rgba(255,255,255,0.15)",
            }}
          />
        ))}
      </div>

      {/* Labels below bar */}
      {(leftLabel || rightLabel) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 6,
            fontSize: 12,
            color: colors.grayLight,
          }}
        >
          <span>{leftLabel}</span>
          <span>{rightLabel}</span>
        </div>
      )}
    </div>
  );
}
